export default "/_next/static/chunks/fonts/Funnel Display Regular-1d318860ca4d9add12024b264f38cfa5.ttf";